import { render, staticRenderFns } from "./queryQuotationRecord.vue?vue&type=template&id=628c933e&scoped=true&"
import script from "./queryQuotationRecord.vue?vue&type=script&lang=js&"
export * from "./queryQuotationRecord.vue?vue&type=script&lang=js&"
import style0 from "./queryQuotationRecord.vue?vue&type=style&index=0&id=628c933e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c933e",
  null
  
)

export default component.exports